import Isotope from 'isotope-layout';

const isotopeGrid = document.querySelectorAll('.js-isotope-grid');
if (isotopeGrid.length) {
  const options = {
    itemSelector: '.grid-item',
    percentPosition: true,
    transitionDuration: 300,

    masonry: {
      gutter: '.gutter-sizer',
      columnsWidth: '.grid-sizer',
    },
  };

  // <editor-fold desc="Filters">
  let isoSelectedElements = null;
  const filterSelectedElements = (itemElem, filterValue) => {
    isoSelectedElements ??= Array.from(itemElem.parentElement
      .querySelectorAll(`[data-filter*="${filterValue}"]`));
    return isoSelectedElements.includes(itemElem);
  };
  // </editor-fold>

  isotopeGrid.forEach((isotopeGridContainer) => {
    // eslint-disable-next-line no-new
    const iso = new Isotope(isotopeGridContainer, {
      ...options,
    });

    const filterContainer = isotopeGridContainer.parentElement.querySelector('.js-isotope-filter');
    if (filterContainer) {
      filterContainer.addEventListener('click', (ev) => {
        if (ev.target.tagName === 'BUTTON') {
          const { filter } = ev.target.dataset;
          ev.target.parentElement.querySelectorAll('button')
            .forEach((el) => el.removeAttribute('disabled'));
          ev.target.setAttribute('disabled', true);

          isoSelectedElements = null;
          iso.arrange({ filter: (itemElem) => filterSelectedElements(itemElem, filter) });
        }
      });
    }

    iso.on('arrangeComplete', (items) => {
      items.forEach((item, index) => {
        const { element } = item;
        element.classList.remove('smaller-item');
        if ((index + 1) % 3 === 0) {
          element.classList.add('smaller-item');
        }
      });
      setTimeout(() => {
        iso.layout();
      }, 100);
    });
  });
}
